import { Link } from "react-router-dom";
import '../Jugadores.css';
import Card from "../Card.js";
import Grandoli from '../Fotos/Grandoli.png'
import data from '../datosmessi.json';
import LazyLoad from 'react-lazyload';
import { useState, useEffect } from "react";

function Titulo() {
  useEffect(() => {
    document.title = 'Lionel Messi';
  }, []);
}

function MyComponent() {  
  const uniqueEquipos = [...new Set(data.map(item => item.Equipo))];
  const [selectedEquipo, setSelectedEquipo] = useState('0');

  const uniqueRivales = [...new Set(data.map(item => item.Rival))];
  const [selectedRival, setSelectedRival] = useState('0');

  const uniqueTemporadas = [...new Set(data.map(item => item.Temporada))];
  const [selectedTemporada, setSelectedTemporada] = useState('0');

  const uniqueCompeticiones = [...new Set(data.map(item => item.Competicion))];
  const [selectedCompeticion, setSelectedCompeticion] = useState('0');

  const uniqueVideos = [...new Set(data.map(item => item.Video))];
  const [selectedVideo, setSelectedVideo] = useState('0');

  // Función para filtrar los datos según el equipo seleccionado
  const filteredData = data.filter(item => {
      return (
        (selectedEquipo === '0' || item.Equipo === selectedEquipo) &&
        (selectedRival === '0' || item.Rival === selectedRival) &&
        (selectedTemporada === '0' || item.Temporada === selectedTemporada) &&
        (selectedCompeticion === '0' || item.Competicion === selectedCompeticion) &&
        (selectedVideo === '0' || item.Video !== "")
      );
    });

  // Función para manejar el cambio en el select
  const handleSelectChange = event => {
      const { name, value } = event.target;
      
      if (name === 'equipo') {
        setSelectedEquipo(event.target.value);
      } else if (name === 'rival') {
        setSelectedRival(event.target.value);
      } else if (name === 'temporada') {
          setSelectedTemporada(event.target.value);
      } else if (name === 'competicion') {
          setSelectedCompeticion(event.target.value);
      } else if (name === 'video') {
          setSelectedVideo(event.target.value);
      }
    };

  // Función para mostrar todos los equipos nuevamente
  const resetFilters = () => {
    setSelectedEquipo('0');
    setSelectedRival('0');
    setSelectedTemporada('0');
    setSelectedCompeticion('0');
    setSelectedVideo('0');
  };

  return (
    <>
    <div className="selectcontainer">
          <select
      className="selectequipos"
      name="equipo"
      value={selectedEquipo}
      onChange={handleSelectChange}
      >
      <option value="0">Elegir equipo</option>
      {uniqueEquipos.map((equipo, index) => (
        <option key={index} value={equipo}>
          {equipo}
        </option>
      ))}
      </select>

      <select
      className="selectrivales"
      name="rival"
      value={selectedRival}
      onChange={handleSelectChange}
      >
      <option value="0">Elegir rival</option>
      {uniqueRivales.sort().map((rival, index) => (
        <option key={index} value={rival}>
          {rival}
        </option>
      ))}
      </select>

      <select
      className="selecttemporadas"
      name="temporada"
      value={selectedTemporada}
      onChange={handleSelectChange}
      >
      <option value="0">Elegir temporada</option>
      {uniqueTemporadas.map((temporada, index) => (
        <option key={index} value={temporada}>
          {temporada}
        </option>
      ))}
      </select>

      <select
      className="selectcompeticiones"
      name="competicion"
      value={selectedCompeticion}
      onChange={handleSelectChange}
      >
      <option value="0">Elegir competición</option>
      {uniqueCompeticiones.map((competicion, index) => (
        <option key={index} value={competicion}>
          {competicion}
        </option>
      ))}
      </select>
          <br></br>
          <select
      className="selectvideos"
      name="video"
      value={selectedVideo}
      onChange={handleSelectChange}
      >
      <option value="0">Incluir partidos sin video</option>
      <option value="1">Solo partidos con video</option>
      </select>
      <button className="boton" onClick={resetFilters}>Restablecer</button>
    </div>

      {filteredData.map((item, index) => (
        <LazyLoad key={index} height={200} offset={100} once>
          <Card
            equipo={item.Equipo}
            logoequipo={item["Logo Equipo"]}
            rival={item.Rival}
            fecha={item.Fecha}
            temporada={item.Temporada}
            competicion={item.Competicion}
            minutos={item.Minutos}
            gol={item.Goles}
            asistencias={item.Asistencias}
            video={item.Video ? item.Video : null}
          />
        </LazyLoad>
      ))}
    </>
  );
}

function Messi()
{
    return(
      <>
      <Titulo />
    <section className="main">
        <img className="banner" src='https://assets.goal.com/v3/assets/bltcc7a7ffd2fbf71f5/blt3125544effd09308/639f60c65d0ea95c1ee0e6c3/GettyImages-1450106798.jpg?format=pjpg&auto=webp&width=3840&quality=60'></img>
        <div className="Nombre">LIONEL MESSI</div>
        <div className="Container">
            <MyComponent />

            {/* < Card resultado="Desconocido" goles='?  -  ?' logolocal="https://upload.wikimedia.org/wikipedia/en/5/5a/Black_question_mark.png" nombrelocal='Amanecer' logovisitante={Grandoli} nombrevisitante='Grandoli' fecha='29/05/1993' temporada='1993' competicion='Fútbol Infantil' fase='?' condicion='Visitante' minutos='?' gol='4' asistencias='0' video='https://www.youtube.com/embed/TjUDd1rCfeM'/>

            < Card resultado="Victoria" goles='0  -  6' logolocal="https://rosariofutbol.com/imagenes/archivos/deportesequipos/115_imagen_200.png?random=1688644424" nombrelocal='Pablo VI' logovisitante='https://2.bp.blogspot.com/-MCWnRyuesC8/WWZoSZHcYuI/AAAAAAABMu4/CCeDzDefZnwo-GCV-jzT3jfZjX2-Jj77ACLcBGAs/s1600/Club%2BAtletico%2BNewells%2BOld%2BBoys256x.png' nombrevisitante='Newell´s Old Boys' fecha='09/04/1994' temporada='1994' competicion='Categoría 87´' fase='Liga' condicion='Visitante' minutos='?' gol='4' asistencias='?'/>

            < Card resultado="Desconocido" goles='?  -  ?' logolocal="https://upload.wikimedia.org/wikipedia/en/5/5a/Black_question_mark.png" nombrelocal='?' logovisitante='https://2.bp.blogspot.com/-MCWnRyuesC8/WWZoSZHcYuI/AAAAAAABMu4/CCeDzDefZnwo-GCV-jzT3jfZjX2-Jj77ACLcBGAs/s1600/Club%2BAtletico%2BNewells%2BOld%2BBoys256x.png' nombrevisitante='Newell´s Old Boys' fecha='07/05/1994' temporada='1994' competicion='Categoría 87´' fase='Liga' condicion='?' minutos='?' gol='1' asistencias='0'/>

            < Card resultado="Desconocido" goles='?  -  ?' logolocal="https://rosariofutbol.com/imagenes/archivos/deportesequipos/98_imagen_200.png?random=1688825975" nombrelocal='Tiro Suizo' logovisitante='https://2.bp.blogspot.com/-MCWnRyuesC8/WWZoSZHcYuI/AAAAAAABMu4/CCeDzDefZnwo-GCV-jzT3jfZjX2-Jj77ACLcBGAs/s1600/Club%2BAtletico%2BNewells%2BOld%2BBoys256x.png' nombrevisitante='Newell´s Old Boys' fecha='15/10/1994' temporada='1994' competicion='Categoría 87´' fase='Liga' condicion='?' minutos='?' gol='?' asistencias='?' video='https://www.youtube.com/embed/RS4KxxjyODw'/>
                
            < Card resultado="Victoria" goles='2  -  0' logolocal="https://upload.wikimedia.org/wikipedia/commons/3/3b/Central_C%C3%B3rdoba_Rosario_Escudo.svg" nombrelocal='Central Córdoba' logovisitante='https://rosariofutbol.com/imagenes/archivos/deportesequipos/118_imagen_200.png?random=1688643266' nombrevisitante='Social Lux' fecha='10/09/1995' temporada='1995' competicion='Torneo Infantil' fase='Final' condicion='Local' minutos='?' gol='1' asistencias='0' video='https://www.youtube.com/embed/u79kg4869iI'/>
                
            < Card resultado="Victoria" goles='0  -  10' logolocal="https://3.bp.blogspot.com/-nqq75XdBY6A/WV6vZY-O5SI/AAAAAAABL9Q/nE29GPP_YxErpQ15fC79qVWuPUpwtMYnwCLcBGAs/s1600/Academia%2BDeportiva%2BCantolao256x.png" nombrelocal='Cantolao Cat. 89´' logovisitante='https://2.bp.blogspot.com/-MCWnRyuesC8/WWZoSZHcYuI/AAAAAAABMu4/CCeDzDefZnwo-GCV-jzT3jfZjX2-Jj77ACLcBGAs/s1600/Club%2BAtletico%2BNewells%2BOld%2BBoys256x.png' nombrevisitante='Newell´s Old Boys' fecha='?/?/1997' temporada='1997' competicion='Copa Amistad' fase='Semifinal' condicion='Visitante' minutos='?' gol='7' asistencias='0' video='https://www.youtube.com/embed/SNGKkRmWQxI'/>
                
            < Card resultado="Victoria" goles='1  -  7' logolocal="https://3.bp.blogspot.com/-nqq75XdBY6A/WV6vZY-O5SI/AAAAAAABL9Q/nE29GPP_YxErpQ15fC79qVWuPUpwtMYnwCLcBGAs/s1600/Academia%2BDeportiva%2BCantolao256x.png" nombrelocal='Cantolao Cat. 87´' logovisitante='https://2.bp.blogspot.com/-MCWnRyuesC8/WWZoSZHcYuI/AAAAAAABMu4/CCeDzDefZnwo-GCV-jzT3jfZjX2-Jj77ACLcBGAs/s1600/Club%2BAtletico%2BNewells%2BOld%2BBoys256x.png' nombrevisitante='Newell´s Old Boys' fecha='?/?/1997' temporada='1997' competicion='Copa Amistad' fase='Final' condicion='Visitante' minutos='?' gol='3' asistencias='0' video='https://www.youtube.com/embed/SNGKkRmWQxI'/> */}

        </div>
    </section>
    </>
    )
}

export default Messi;